import React, { ReactElement } from "react";
import ThumbtackIcon from "./thumbtackIcon";
import styles from "./style.module.scss";

export type ThumbtackOfferType = {
    imageURL: string;
    name: string;
    nearMeURL: string;
    slug: string;
    taskDetails: {
        avgCost: {
            min: number;
            max: number;
        };
        description: string;
        title: string;
    };
};

export default function ThumbtackOffer({
    offer,
}: {
    offer: ThumbtackOfferType;
}): ReactElement {
    return (
        <a
            href={`/offer/${offer.slug ?? ""}&isExternalOffer=true`}
            target="_blank"
            rel="noreferrer"
            className={styles.container}
        >
            <div className={styles.header}>
                <div className={styles.logoContainer}>
                    <img
                        src={offer.imageURL}
                        alt={offer.taskDetails.title}
                        loading="lazy"
                    />
                </div>
                <div className={styles.info}>
                    <h3 className={styles.title}>{offer.taskDetails.title}</h3>
                    <div className={styles.subInfo}>
                        <span>
                            <ThumbtackIcon />
                        </span>
                        <span className={styles.listedBy}>
                            Listed by Thumbtack
                        </span>
                    </div>
                    <div className={styles.startingPrice}>
                        ${offer.taskDetails.avgCost.min}{" "}
                        <span className={styles.startingCost}>
                            Starting Cost
                        </span>
                    </div>
                </div>
            </div>
            <p className={styles.description}>
                {offer.taskDetails.description}
            </p>
            <div className={styles.cta}>Get Matched With Local Pros </div>
        </a>
    );
}
